import { createAction, props } from "@ngrx/store";
import { ISkillGroup } from "@skills-app/models/skillGroup";

const prefix = "[Edit Skill Group Page]";

export const skillGroupEditRequest = createAction(
  `${prefix} Skill Group Edit Request`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const skillGroupEditSuccess = createAction(
  `${prefix} Skill Group Edit Request Success`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const skillGroupEditError = createAction(
  `${prefix} Skill Group Edit Error Error`,
);
